import { useAtom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { LimitOrder } from "#/types/orders";

export const perpLimitOrderTypeAtom = atomWithStorage<LimitOrder>(
  "perpLimitOrderType",
  LimitOrder.GTC,
);

export const usePerpLimitOrderType = () => {
  const [perpLimitOrderType, setPerpLimitOrderType] = useAtom(
    perpLimitOrderTypeAtom,
  );

  return {
    perpLimitOrderType,
    setPerpLimitOrderType,
  };
};
